import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import { GlueCatalogID } from '../../../../Components/MetadataField/MetaGridFields';

export const AWSGlueDatabaseMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        name={metadata}
        createdAt={metadata}
        vpc="None"
        state="None"
        availabilityZone="None"
        owner="None"
      />
      {GlueCatalogID(metadata)}
    </Grid>
  );
};
